import React from 'react';

import debounce from 'lodash/debounce';
import moment from 'moment'
import makeAnimated from 'react-select/animated';
import pl from "date-fns/locale/pl";

import { Tab, Tabs, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker, { registerLocale } from "react-datepicker";
import { FaTrash, FaSearch, FaUserPlus } from 'react-icons/fa';

import FechGetClubInfoByAdminUtils from "../APP_RESERVATION_FECH_DATA/FechGetClubInfoByAdminUtils";
import FechGetClientsBySearchValue from "../APP_RESERVATION_FECH_DATA/FechGetClientsBySearchValue";
import FechGetReservationsBySearch from "../APP_RESERVATION_FECH_DATA/FechGetReservationsBySearch";
import FechPostAddSmsDraft from "../APP_RESERVATION_FECH_DATA/FechPostAddSmsDraft";
import FechGetDeleteSmsDraft from "../APP_RESERVATION_FECH_DATA/FechGetDeleteSmsDraft";
import FechPostSendSmsReservation from "../APP_RESERVATION_FECH_DATA/FechPostSendSmsReservation";
import FechGetSmsDraft from "../APP_RESERVATION_FECH_DATA/FechGetSmsDraft";
import FechGetSmsSent from "../APP_RESERVATION_FECH_DATA/FechGetSmsSent";
import FechGetClubSettings from "../APP_RESERVATION_FECH_DATA/FechGetClubSettings";

import EditClientPopupForm from '../APP_RESERVATION_FORM_POPUP/EditClientPopupForm'
import ParseUtilsToField from "../utils/ParseUtilsToField";
import BeltReservationApp from '../APP_RESERVATION_COMPONENTS/BeltReservationApp'

const animatedComponents = makeAnimated();

let plLocate = require('moment/locale/pl');
moment.locale('pl', plLocate)

class PageSms extends React.Component {

    defaultValue = "Wybierz...";

    emptyClientItem = {
        clientId: "",
        promotionId: "",
        phone: "",
        name: "",
        surname: "",
      };

    constructor(props) {
      super(props);
      this.state = {
        editClientPopupForm: "",
        clientItem: this.emptyClientItem,
        selectedClientDesc: null,
        selectedClientDto: null,
        clients: [],
        addedClients: [],
        selectedCourt: null,
        selectedHourStart: null,
        selectedHourStop: null,
        selectedDateReservation: null,
        totalRecords: 0,
        totalShowRecords: 0,
        reservations: [],
        restClientData: {
            successful: false,
            status: '',
            message: '',
            data: []
        },
        restSmsDraftData: {
          successful: false,
          status: '',
          message: '',
          data: []
        },
        restSmsSentData: {
          successful: false,
          status: '',
          message: '',
          data: []
        },
        restClubSettingsData: {
          successful: false,
          status: "",
          message: "",
          data: [],
        },
        courts:[],
        availableHours:[],
        smsMessage: null,
        smsMessageApiError: null,
        smsMessageApiOk: null,
        isSendingSms: false,
        showConfirmModal: false,
        showInfo: false,
        showInfoMsg: null,
        isSearching: false,
        searchingReservationError: null,
      };
      this.debouncedFetchClients = debounce(this.fetchClients, 300);
    }
  
    async componentDidMount() {

      const club = this.props.match?.params?.club ?? "";
      const truncatedClub = club.length > 20 ? club.slice(0, 20) : club;
      const title = "Panel SMS BACKUP" + truncatedClub + " App - RezerwujKort.pl";
      document.title = title;

      if (window._paq) {
        window._paq.push(['setDocumentTitle', title]);
      }

      registerLocale("pl", pl);

      var smsDraftResult = await FechGetSmsDraft(this.props.match.params.club);
      var smsSentResult = await FechGetSmsSent(this.props.match.params.club, 0);
      var results = await FechGetClubInfoByAdminUtils(this.props.match.params.club, true, true, false);
      var setttingsTemp = await FechGetClubSettings(this.props.match.params.club);
      var courtsTemp = ParseUtilsToField.courtListMultiSelectField(results.data);
      const formattedAvailableHours = results.data.availableHours.map((oneRecord) => ({
        value: oneRecord.hour,
        label: oneRecord.hour
      }));
      this.setState({ courts: courtsTemp, 
        availableHours: formattedAvailableHours,
        restSmsSentData: smsSentResult,
        restSmsDraftData: smsDraftResult,
        restClubSettingsData: setttingsTemp});
    }

    handleChangeClient = (selectedOption) => {
      
      const clientDto = this.state.restClientData.data.find(client => client.id === selectedOption.value);
      this.setState({ selectedClientDesc: selectedOption, selectedClientDto: clientDto });
      
      var clientItemTemp = { ...this.emptyClientItem };
      clientItemTemp.clientId = selectedOption?.value || null;
      clientItemTemp.clientName = selectedOption?.label || "";
  
      let currentClientChoose = null;
  
      if (this.state.restClientData.successful) {
          currentClientChoose = ParseUtilsToField.currentClientDataChooseNew(
              this.state.restClientData.data,
              clientItemTemp.clientId
          );
  
          if (currentClientChoose) {
              clientItemTemp.clientId = currentClientChoose.id;
              clientItemTemp.clientName = currentClientChoose.name + " " + currentClientChoose.surname + " (" + currentClientChoose.phone + ")";
              this.setState({ clients: [], clientItem: clientItemTemp });
          }
      }
    };

    handleClientInputChange = (inputValue, actionMeta) => {

      if (actionMeta.action === 'input-change' && inputValue.length >= 2) {
        this.setState({ clients: [] });
        this.debouncedFetchClients(inputValue);
      }
      return inputValue;
    };

    handleClearClientSelect = () => {
      this.setState({ selectedClientDesc: null, clientItem: this.emptyClientItem });
    };

    fetchClients = async (inputValue) => {

        this.setState({ isLoading: true });
        const searchValue = "?searchValue=" + encodeURIComponent(inputValue);
        try {
            const results = await FechGetClientsBySearchValue(this.props.match.params.club, searchValue);
            const clients = results.successful ? ParseUtilsToField.clientsDataField(results.data) : [];
            this.setState({ clients, isLoading: false, restClientData: results });
        } catch (err) {
            this.setState({ clients: [], isLoading: false });
        }
    };

    handleAddClient = () => {

      const { selectedClientDesc, selectedClientDto } = this.state;
      if (!selectedClientDesc) return;
  
      const alreadyExists = this.state.addedClients.some(
          (item) => item.clientId === selectedClientDesc.value
      );
  
      if (!alreadyExists) {
          this.state.addedClients.push({
            selectedClientDto
          });
      }
  
      this.setState({ selectedClientDesc: null, clientItem: { ...this.emptyClientItem } });
    };

    handleAddClientByReservation = (reservation) => {
      const { addedClients } = this.state;
  
      const selectedClientDto = {
        id: reservation.clientId,
        name: reservation.name,
        surname: reservation.surname,
        phone: reservation.phone
      };
      // Sprawdzamy, czy klient już istnieje
      const alreadyExists = addedClients.some(item => item.clientId === reservation.clientId);
  
      if (!alreadyExists) {
        const updatedClients = [...addedClients, { selectedClientDto }];
        this.setState({ addedClients: updatedClients });
      }
    };

    renderClientForm() {
    
      const isClientSelected =
          !!this.state.clientItem.clientName && !!this.state.clientItem.clientId;
  
      return (
          <div
              className="p-4 bg-white"
              style={{
                  borderColor: "#28a745",
                  borderWidth: "2px",
                  borderStyle: "solid",
                  borderRadius: "8px"
              }}
          >
              <Form.Label className="text-start w-100 fw-semibold"
                  style={{ textAlign: "left" }}>
                  <b>Wybierz klienta z listy</b>
              </Form.Label>
  
              <Select
                placeholder="Wybierz klienta"
                id="clientId"
                name="clientId"
                disabled={false}
                value={this.state.selectedClientDesc}
                options={Array.isArray(this.state.clients) ? this.state.clients : []}
                onChange={this.handleChangeClient}
                onInputChange={this.handleClientInputChange}
                isLoading={this.state.isLoading}
              />
  
              {isClientSelected && (
                  <div style={{ marginTop: 20, lineHeight: "25px", textAlign: "left" }}>
                      <b>Wybrany klient: </b> {this.state.clientItem.clientName}
                  </div>
              )}
  
              <div className="d-flex justify-content-end gap-3 mt-4">
                  <Button
                      variant="outline-danger"
                      onClick={this.handleClearClientSelect}
                      className="fw-bold border-2 d-flex align-items-center gap-2 px-4 py-2"
                      style={{ borderWidth: "3px" }}
                  >
                      <FaTrash style={{ marginRight: "10px" }} />
                      Wyczyść
                  </Button>
  
                  <Button
                    variant={isClientSelected ? "outline-success" : "secondary"}
                    onClick={this.handleAddClient}
                    disabled={!isClientSelected}
                    className="fw-bold border-2 d-flex align-items-center gap-2 px-4 py-2"
                    style={{
                        borderWidth: "3px",
                        marginLeft: "10px",
                        cursor: isClientSelected ? "pointer" : "not-allowed",
                        opacity: isClientSelected ? 1 : 0.65
                    }}
                  >
                  <FaUserPlus style={{ marginRight: "10px" }} />
                      Dodaj klienta
                  </Button>
              </div>
          </div>
        );
    }

    handleClearSmsForm = () => {
      this.setState({
        smsMessage: '',
        addedClients: []
      });
    };

    handleRemoveClient = (indexToRemove) => {
      const { addedClients } = this.state;
    
      const updatedClients = addedClients.filter((_, index) => index !== indexToRemove);
    
      this.setState({ addedClients: updatedClients });
    };

    handleSaveTemplate = async () => {
      this.setState({ isSendingSms: true });
      await new Promise(resolve => setTimeout(resolve, 500));
      await FechPostAddSmsDraft(this.props.match.params.club, {
        message: this.state.smsMessage
      });
      var smsDraftResult = await FechGetSmsDraft(this.props.match.params.club);
      this.setState({
        restSmsDraftData: smsDraftResult,
        isSendingSms: false,
        showInfo: true,
        showInfoMsg: "Szablon wiadomości został zapisany."
      });
    };

    handleDeleteSmsDraft = async (id) => {
      await FechGetDeleteSmsDraft(this.props.match.params.club, id);
      var smsDraftResultTemp = await FechGetSmsDraft(this.props.match.params.club);
      this.setState({
        restSmsDraftData: smsDraftResultTemp,
        showInfo: true,
        showInfoMsg: "Szablon wiadomości został usunięty."
      });
    };

    confirmAndSendSms = () => {
      this.setState({ showConfirmModal: false }, () => {
        this.handleSentSms();
      });
    };

    confirmSendSms = () => {
      this.setState({ showConfirmModal: true });
    };
    
    handleSentSms = async () => {
      this.setState({ isSendingSms: true });
    
      await new Promise(resolve => setTimeout(resolve, 1000));

      try {
        const { addedClients, smsMessage } = this.state;
    
        const clients = addedClients
          .map((client) => client.selectedClientDto)
          .filter((c) => c && c.id);
    
        const body = {
          message: smsMessage || "",
          clients: clients.map(({ id, name, surname, phone }) => ({
            id,
            name,
            surname,
            phone,
          })),
        };
    
        const response = await FechPostSendSmsReservation(this.props.match.params.club, body);
    
        if (response.status !== 200 && response.message !== "") {
          this.setState({
            smsMessageApiError: response.message,
            smsMessageApiOk: null,
          });
        } else if (response.status >= 200 && response.status < 300) {
          var smsSentResult = await FechGetSmsSent(this.props.match.params.club, 0);
          this.setState({
            smsMessageApiError: null,
            smsMessage: '',
            addedClients: [],
            restSmsSentData: smsSentResult,
            smsMessageApiOk: "Wiadomość została wysłana"
          });
        }
      } catch (error) {
        this.setState({
          smsMessageApiError: "Wystąpił nieoczekiwany błąd podczas wysyłania wiadomości.",
          smsMessageApiOk: null
        });
      } finally {
        this.setState({ isSendingSms: false });
      }
    };

    // async handlerRefreshReservation() {
    //   var refreash = this.props.refresh();
    // }

    // async handleEditClient(clientId) {

    //   this.setState({
    //     editClientPopupForm: <EditClientPopupForm
    //       club={this.props.match.params.club}
    //       refresh={this.handlerRefreshReservation}
    //       clientId={clientId}
    //     />
    //   });
    // }

    renderSmsForm() {

      const recipients = this.state.addedClients.map((client, index) => {
        const { id = "", name = "", surname = "", phone = "" } = client.selectedClientDto || {};
        return { id, name, surname, phone, index };
      });
    
      return (
        <div className="container mt-3" style={{ maxWidth: '100%', padding: '0' }}>
          <div
            className="rounded p-4 "
            style={{ border: '2px solid #155724' }} // Ciemnozielony kolor obramowania
          >
            {this.state.smsMessageApiError && (
              <div style={{
                backgroundColor: '#ffe6e6',
                color: '#b30000',
                border: '1px solid #b30000',
                borderRadius: '8px',
                marginBottom: '20px',
                marginTop: '20px',
                padding: '12px 16px',
                marginTop: '16px',
                fontSize: '14px'
              }}>
                <strong>Błąd:</strong> {this.state.smsMessageApiError}
              </div>
            )}

            {this.state.smsMessageApiOk && (
              <div style={{
                backgroundColor: '#e6ffe6',
                color: '#006600',
                border: '1px solid #006600',
                borderRadius: '8px',
                marginBottom: '20px',
                marginTop: '20px',
                padding: '12px 16px',
                marginTop: '16px',
                fontSize: '14px'
              }}>
                <strong>Sukces:</strong> {this.state.smsMessageApiOk}
              </div>
            )}

              <div className="mb-3">
                {recipients.length > 0 ? (
                  <>
                    <label className="form-label fw-semibold">
                      <b>Odbiorcy (imię, nazwisko i numer telefonu):</b>
                    </label>
    
                    <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                      <table 
                        className="table w-100"
                        style={{
                          border: '0.5px solid #006400', // ciemnozielone obramowanie
                          borderRadius: '8px', // zaokrąglone rogi
                          boxShadow: '0 4px 6px rgba(0, 100, 0, 0.1)', // subtelny cień
                          borderCollapse: 'collapse', // zapobiega podwójnemu obramowaniu w komórkach
                        }}
                      >
                        <thead>
                          <tr>
                            {/* Możesz dodać tutaj nagłówki, jeśli chcesz */}
                          </tr>
                        </thead>
                        <tbody>
                          {recipients.map((r, idx) => (
                            <tr key={idx} >
                              <td style={{ border: 'none' }}>
                                <div className="fw-semibold">{r.name} {r.surname} {r.phone}</div>
                              </td>
                              {/* <td style={{ border: 'none' }}>
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm w-100"
                                  onClick={() => this.handleEditClient(r.id)}
                                >
                                  Edytuj
                                </button>
                              </td> */}
                              <td style={{ border: 'none' }}>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm w-100"
                                  onClick={() => this.handleRemoveClient(r.index)}
                                >
                                  Usuń z listy
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <div className="fw-bold text-dark">
                    <b>Korzystając z panelu obok dodaj osoby do<br/> których wysłana zostanie wiadomość SMS</b>
                  </div>
                )}
              </div>
    
              <div className="mb-3">
                <label
                  className="form-label fw-semibold"
                  style={{ textAlign: 'left', display: 'block' }}
                >
                  <b>Treść wiadomości (Ilość znaków: {(this.state.smsMessage || '').length} )</b>
                </label>
                <textarea
                  className="form-control"
                  style={{ width: '95%' }}
                  rows="3"
                  maxLength="160"
                  placeholder="Wpisz treść wiadomości (max 160 znaków)"
                  value={this.state.smsMessage || ""}
                  onChange={(e) => this.setState({ smsMessage: e.target.value })}
                />
              </div>
    
              <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="d-flex gap-2" style={{ width: '60%' }}>
                  <button
                    type="button"
                    className="btn btn-outline-danger w-50"
                    onClick={this.handleClearSmsForm}
                    disabled={this.state.isSendingSms}
                  >
                    🗑 Wyczyść
                  </button>
      
                  <button
                    type="button"
                    className="btn btn-outline-secondary w-50"
                    onClick={this.handleSaveTemplate}
                    disabled={this.state.isSendingSms}
                  >
                    💾 Zapisz szablon
                  </button>
                </div>
    
                <button
                  className="btn btn-success fw-semibold"
                  style={{ width: '35%', paddingTop: '2%', paddingBottom: '2%' }}
                  onClick={this.confirmSendSms}
                  disabled={this.state.isSendingSms}
                >
                  {this.state.isSendingSms ? "📤 Wysyłanie..." : "✉️ Wyślij wiadomość"}
                </button>
              </div>
            
          </div>

        </div>
      );
    }
    
    handleChangeDate = (date, fieldName) => {
      this.setState({
        [fieldName]: date,
      });
    };

    handleClearFindByReservation = () => {
      this.setState({ selectedCourt: null, 
        selectedHourStart: null,
        selectedHourStop: null,
        selectedDateReservation: null, 
        totalShowRecords: 0,
        totalRecords: 0,
        reservations: [] });
    };

    handleSearchByReservation = async () => {
      const {
        selectedDateReservation,
        selectedCourt,
        selectedHourStart,
        selectedHourStop,
      } = this.state;
    
      // 🔒 WALIDACJA
      if (!selectedDateReservation || !selectedCourt || !selectedHourStart || !selectedHourStop) {
        this.setState({ searchingReservationError: "Wszystkie pola: data, kort, godzina start i godzina koniec muszą być uzupełnione." });
        return;
      }else{
        this.setState({ searchingReservationError: null });
      }
    
      try {
        this.setState({ isSearching: true });
    
        const formatDate = (date) =>
          date
            ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
            : '';
        const dateReservation = formatDate(selectedDateReservation);
    
        const url = `?page=1&dateStart=${dateReservation}&dateStop=${dateReservation}&hourStart=${selectedHourStart.value}&hourStop=${selectedHourStop.value}&status=1$&courtId=${selectedCourt.value}`;
    
        const results = await FechGetReservationsBySearch(
          this.props.match.params.club,
          url
        );
    
        console.log(results);
        if (results.status === 200) {
          const reservationsShowTemp = Math.min(
            results.data.recordsOnPage,
            results.data.totalRecordsCount
          );
          this.setState({
            searchResults: results,
            totalRecords: results.data.totalRecordsCount,
            totalShowRecords: reservationsShowTemp,
            reservations: results.data.reservationResources,
          });
        }
      } catch (error) {
        console.error("Błąd podczas pobierania danych:", error);
      } finally {
        this.setState({ isSearching: false });
      }
    };

    loadSmsPage = async (page) => {
      var smsSentResult = await FechGetSmsSent(this.props.match.params.club, page);

      this.setState({ restSmsSentData: smsSentResult});
    };

    renderFindClientsByReservations() {
      const { animatedComponents, defaultValue } = this;
    
      return (
        <div className="border border-2 rounded p-4 bg-white">
          {this.state.searchingReservationError && (
              <div style={{
                backgroundColor: '#ffe6e6',
                color: '#b30000',
                border: '1px solid #b30000',
                borderRadius: '8px',
                marginBottom: '20px',
                marginTop: '20px',
                padding: '12px 16px',
                marginTop: '16px',
                fontSize: '14px'
              }}>
                <strong>Błąd:</strong> {this.state.searchingReservationError}
              </div>
            )}
          <div className="d-flex flex-wrap gap-3">
    
            {/* Kort */}
            <div style={{ minWidth: "20%", flex: "1" }}>
              <Form.Group controlId="formGridCourt">
                <Form.Label className="fw-semibold">Wybierz kort</Form.Label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  placeholder={defaultValue}
                  options={this.state.courts}
                  value={this.state.selectedCourt}
                  onChange={(selectedOption) => {
                    this.setState({ selectedCourt: selectedOption });
                  }}
                />
              </Form.Group>
            </div>
    
            {/* Godzina start */}
            <div style={{ minWidth: "20%", maxWidth: "20%", flex: "1", marginLeft:'10px', marginRight:'10px' }}>
              <Form.Group controlId="formGridHourStart">
                <Form.Label className="fw-semibold">Godzina start</Form.Label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  placeholder={defaultValue}
                  options={this.state.availableHours}
                  value={this.state.selectedHourStart}
                  onChange={(selectedOption) => {
                    this.setState({ selectedHourStart: selectedOption });
                  }}
                />
              </Form.Group>
            </div>
    
            {/* Godzina koniec */}
            <div style={{ minWidth: "20%", maxWidth: "20%", flex: "1", marginRight:'10px' }}>
              <Form.Group controlId="formGridHourStop">
                <Form.Label className="fw-semibold">Godzina koniec</Form.Label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  placeholder={defaultValue}
                  options={this.state.availableHours}
                  value={this.state.selectedHourStop}
                  onChange={(selectedOption) => {
                    this.setState({ selectedHourStop: selectedOption });
                  }}
                />
              </Form.Group>
            </div>
    
            {/* Data */}
            <div style={{ minWidth: "180px", flex: "1" }}>
              <Form.Group controlId="formGridDate">
                <Form.Label className="fw-semibold">Data start</Form.Label>
                <DatePicker
                  selected={this.state.selectedDateReservation}
                  value={this.state.selectedDateReservation}
                  onChange={(date) => this.handleChangeDate(date, "selectedDateReservation")}
                  dateFormat="yyyy-MM-dd"
                  locale={pl}
                  calendarStartDay={1}
                  className="form-control"
                />
              </Form.Group>
            </div>
    
          </div>
    
          {/* Przycisk wyczyść / szukaj */}
          <div className="d-flex justify-content-end gap-3 mt-4">
            <Button
              variant="outline-danger"
              onClick={this.handleClearFindByReservation}
              className="fw-bold border-2 d-flex align-items-center gap-2 px-4 py-2"
              style={{ borderWidth: "3px" }}
            >
              <FaTrash style={{ marginRight: "10px" }} />
              Wyczyść
            </Button>
    
            <Button
              variant="outline-success"
              onClick={this.handleSearchByReservation}
              disabled={this.state.isSearching}
              className="fw-bold border-2 d-flex align-items-center gap-2 px-4 py-2"
              style={{ borderWidth: "3px", marginLeft: "10px" }}
            >
              <FaSearch style={{ marginRight: "10px" }} />
              {this.state.isSearching ? 'Szukam...' : 'Szukaj'}
            </Button>
          </div>
    
          {/* Tabela wyników */}
          <div className="mb-3 mt-4">
            <label className="form-label fw-semibold">
              Łącznie rekordów: {this.state.totalRecords} &nbsp;|&nbsp; Wyświetlono: {this.state.totalShowRecords}
            </label>
    
            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Klient</th>
                    <th>Rezerwacja</th>
                    <th>Akcja</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.reservations.map((r, index) => (
                    <tr key={index}>
                      <td>
                        <div>{r.name} {r.surname}</div>
                        <div className="text-muted">{r.phone}</div>
                      </td>
                      <td>
                        <div>{r.date} {r.dayOfWeek}</div>
                        <div>{r.hourStart}-{r.hourStop}</div>
                        <div className="text-muted">{r.courtName}</div>
                      </td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => this.handleAddClientByReservation(r)}
                        >
                          Dodaj klienta
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    }

    renderSmsDrafts() {
      const { restSmsDraftData } = this.state;
    
      return (
        <div className="mb-3">
          <label className="form-label fw-semibold">Szablony wiadomości:</label>
    
          {restSmsDraftData.status === 200 && restSmsDraftData.data.length > 0 ? (
            <div style={{ maxHeight: '520px', overflowY: 'auto', overflowX: 'hidden' }}>
              <ul className="list-group">
                {restSmsDraftData.data.map((draft, index) => (
                  <li
                    key={draft.id || index}
                    className="list-group-item list-group-item-action d-flex align-items-start"
                    style={{
                      cursor: 'pointer',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      textAlign: 'left',
                    }}
                    onClick={() => this.setState({ smsMessage: draft.message })}
                  >
                    <div style={{ flex: '0 1 auto', width: '90%' }}>{draft.message}</div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger ms-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleDeleteSmsDraft(draft.id);
                      }}
                    >
                      ❌
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className="text-muted">Brak zapisanych szablonów.</div>
          )}
        </div>
      );
    }
    
    renderSmsSentContent() {

      const { restSmsSentData } = this.state;
    
      if (!restSmsSentData || !restSmsSentData.successful) {
        return (
          <div className="card-body">
            <div className="alert alert-info text-center">
              Brak rekordów do wyświetlenia.
            </div>
          </div>
        );
      }
    
      const currentPage = restSmsSentData.data.page;
      const totalPages = restSmsSentData.data.totalPages;
    
      const paginationItems = [];
      const createPageItem = (page) => (
        <li
          key={page}
          className={`page-item ${page === currentPage ? "active" : ""}`}
          onClick={() => this.loadSmsPage(page)}
        >
          <button className="page-link">{page + 1}</button>
        </li>
      );
    
      if (totalPages <= 7) {
        // Mało stron - pokazujemy wszystkie
        for (let i = 0; i < totalPages; i++) {
          paginationItems.push(createPageItem(i));
        }
      } else {
        paginationItems.push(createPageItem(0)); // pierwsza strona
    
        if (currentPage > 3) {
          paginationItems.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
        }
    
        const startPage = Math.max(1, currentPage - 1);
        const endPage = Math.min(totalPages - 2, currentPage + 1);
    
        for (let i = startPage; i <= endPage; i++) {
          paginationItems.push(createPageItem(i));
        }
    
        if (currentPage < totalPages - 4) {
          paginationItems.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
        }
    
        paginationItems.push(createPageItem(totalPages - 1)); // ostatnia strona
      }
    
      return (
        <div className="card-body" style={{ fontSize: '12px' }}>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Dane klienta</th>
                <th>Treść wiadomości</th>
                <th>Wysłane przez</th>
                <th>Data wysłania</th>
              </tr>
            </thead>
            <tbody>
              {restSmsSentData.data.content.map((sms, index) => (
                <tr key={index}>
                  <td>{sms.name} {sms.surname}<br/>{sms.phone}</td>
                  <td>{sms.message}</td>
                  <td>{sms.sentByName} {sms.sentBySurname}<br/>{sms.sentByEmail}</td>
                  <td>{sms.createdAt}</td>
                </tr>
              ))}
            </tbody>
          </table>
    
          {/* Paginacja */}
          <nav>
            <ul className="pagination justify-content-center">
              {paginationItems}
            </ul>
          </nav>
        </div>
      );
    }

    render() {
      return (
          <div>
              <div id="content">
                  <BeltReservationApp club={this.props.match.params.club} />
                  {this.state.restClubSettingsData.successful && this.state.restClubSettingsData.data.smsPanel == false && (
                    <div style={{
                      backgroundColor: '#ffe6e6',
                      color: '#b30000',
                      border: '1px solid #b30000',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      fontSize: '14px',
                      width: '30%',
                      margin: '40px auto',
                      textAlign: 'center',
                    }}>
                      <strong>Funkcjonalność wyłączona</strong>
                    </div>
                  )}
                  {this.state.editClientPopupForm}
                  <div className="text-center">
                      <h1 className="h4 fw-bold text-dark mb-3" style={{ paddingTop: '2%', paddingBottom: '2%' }}>Wiadomości SMS</h1>
  
                      <div className="d-flex flex-column flex-md-row text-start">
                        {/* Lewa część */}
                        <div
                          className="d-flex flex-column"
                          style={{
                            width: '40%',
                            marginLeft: '2%',
                            marginRight: '2%',
                            marginBottom: '2%',
                          }}
                        >
                          {this.renderSmsForm()}
                        </div>

                        {/* Prawa część z kartami */}
                        <div
                          className="d-flex flex-column"
                          style={{
                            width: '54%',
                            marginRight: '2%',
                            marginBottom: '2%',
                          }}
                        >
                          <Tabs defaultActiveKey="clients" id="message-tabs" className="mb-3">
                            <Tab eventKey="clients" title="Klienci">
                              <div className="card-body">{this.renderClientForm()}</div>
                            </Tab>
                            <Tab eventKey="reservations" title="Rezerwacje">
                              <div className="card-body">{this.renderFindClientsByReservations()}</div>
                            </Tab>
                            <Tab eventKey="drafts" title="Szablony wiadomości">
                              <div className="card-body">{this.renderSmsDrafts()}</div>
                            </Tab>
                            <Tab eventKey="sent" title="Wysłane SMS-y">
                              {this.renderSmsSentContent()}
                            </Tab>
                          </Tabs>
                        </div>
                      </div>
                      {this.state.showConfirmModal && (
                        <div
                          className="modal fade show"
                          tabIndex="-1"
                          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Potwierdzenie</h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={() => this.setState({ showConfirmModal: false })}
                                />
                              </div>
                              <div className="modal-body">
                                <p>Czy na pewno chcesz wysłać wiadomość?</p>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => this.setState({ showConfirmModal: false })}
                                  disabled={this.state.isSendingSms}
                                >
                                  Anuluj
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-success"
                                  onClick={this.confirmAndSendSms}
                                  disabled={this.state.isSendingSms}
                                >
                                  Tak, wyślij
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}



{this.state.showInfo && (
                        <div
                          className="modal fade show"
                          tabIndex="-1"
                          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Potwierdzenie</h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={() => this.setState({ showInfo: false })}
                                />
                              </div>
                              <div className="modal-body">
                                <p>{this.state.showInfoMsg}</p>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => this.setState({ showInfo: false })}
                                  disabled={this.state.isSendingSms}
                                >
                                  OK
                                </button>
                                {/* <button
                                  type="button"
                                  className="btn btn-success"
                                  onClick={this.confirmAndSendSms}
                                  disabled={this.state.isSendingSms}
                                >
                                  Tak, wyślij
                                </button> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      
                  </div>
              </div>
          </div>
      );
  }
}
export default PageSms;